import { render, staticRenderFns } from "./VocalManagePage.vue?vue&type=template&id=24ea559a&scoped=true&"
import script from "./VocalManagePage.vue?vue&type=script&lang=js&"
export * from "./VocalManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea559a",
  null
  
)

export default component.exports